import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useLocalObservable } from "mobx-react-lite";
import { getProfile } from "../services/PersonalService";
import StoreAction from "./StoreAction";

const initialState = {
  username: "",
  email: "",
  profile_picture: "",
  experience: "",
  birthday: new Date(),
  gender: "男",
  softPower: "",
  hardPower: "",
  motivation: "",
  applyTeam: {},
  igLink: "",
  fbLink: "",
  linkedInLink: "",
  teamid: ""
  // selectedObject: "",
};
const PersonalStore = () => {
  const store = useLocalObservable(() => ({
    /*observables*/
    ...initialState,
    ...StoreAction(initialState),
    handleInputChange(text, index) {
      this.deeds[index] = text;
    },
    // addInput() {
    //   this.deeds.push("");
    // },
    addTeam(teamId, pos) {
      this.applyTeam[teamId] = pos;
    },
    // removeInput() {
    //   this.deeds.pop();
    // },
  }));

  const auth = getAuth();
  onAuthStateChanged(auth, (user) => {
    console.log("personal store");
    if (user) {
      getProfile().then((value) => {
        if (value) {
          store.updateData("username", value.username);
          store.updateData("profile_picture", value.profile_picture);
          store.updateData("gender", value.gender);
          store.updateData("birthday", value.birthday);
          store.updateData("email", value.email);
          store.updateData("experience", value.experience);
          store.updateData("softPower", value.softPower);
          store.updateData("hardPower", value.hardPower);
          store.updateData("motivation", value.motivation);
          store.updateData("igLink", value.igLink ? value.igLink : "");
          store.updateData("fbLink", value.fbLink ? value.fbLink : "");
          store.updateData("linkedInLink", value.linkedInLink ? value.linkedInLink : "");
          store.updateData("teamid", value.teamId ? value.teamId : "");
          // for (const key in value.deeds) {
          //   store.addInput();
          //   store.handleInputChange(value.deeds[key], key);
          // }
          for (const key in value.applyTeam) {
            store.addTeam(key, value.applyTeam[key]);
          }
        }
      });
    }
  });

  return store;
};

export default PersonalStore;
